import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row } from 'antd';
import CompanySearch from '@comm/companySearch';
import { BackBtn } from '@comm/BackBtn';

const FormItem = Form.Item;
const { TextArea } = Input;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        handSubmit(values);
      }
    });
  };

  handleCompanyChange = (value, option) => {
    this.props.form.setFieldsValue({
      compName: option.props.children,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { dataInfo, goBack } = this.props;
    getFieldDecorator('compName', {
      rules: [
        {
          required: true,
          message: '请选择公司',
        },
      ],
      initialValue: dataInfo.compName,
    });
    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };
    const ItemLayout2 = {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    };
    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
          <Button type="primary" style={{ marginRight: 10 }} htmlType="submit">
            确认
          </Button>
        </div>
        <Card>
          <Row>
            <Col span={10}>
              <FormItem label="公司名称" {...ItemLayout}>
                {getFieldDecorator(`compUuid`, {
                  initialValue: dataInfo.compUuid,
                })(
                  <CompanySearch
                    companyName={dataInfo.compName}
                    companyUuid={dataInfo.compUuid}
                    onChange={(value, option) => this.handleCompanyChange(value, option)}
                    {...this.props}
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="开户行" {...ItemLayout}>
                {getFieldDecorator('bankName', {
                  initialValue: dataInfo.bankName,
                })(<Input placeholder="开户行" type="text" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="开户帐号" {...ItemLayout}>
                {getFieldDecorator('bankBook', {
                  initialValue: dataInfo.bankBook,
                })(<Input placeholder="开户帐号" type="text" />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="密码" {...ItemLayout}>
                {getFieldDecorator('passwd', {
                  initialValue: dataInfo.passwd,
                })(<Input placeholder="密码" type="text" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="备注" {...ItemLayout2}>
                {getFieldDecorator('remark', {
                  initialValue: dataInfo.remark,
                })(<TextArea placeholder="备注" type="textarea" rows={4} />)}
              </FormItem>
            </Col>
          </Row>
        </Card>
      </Form>
    );
  }
}

export default Form.create()(BaseForm);



// WEBPACK FOOTER //
// ./src/components/finance/receipt/FormBase.js